import ServiceSection from '../PageElements/HomePageElements/ServiceSection'
import ConsultSection from '../PageElements/HomePageElements/ConsultSection'
import NewsMainSection from '../PageElements/NewsPageElements/NewsMainSection'
export default function NewsPage() {
    return (
        <>

            <NewsMainSection/>
            {/* <ServiceSection /> */}
            <ConsultSection />
        </>
    )
}